/**
 * Design tokens NEUTROS del rediseño (fuente de verdad de la UI).
 * Consumir SIEMPRE desde aquí; nunca hardcodear estos valores en componentes.
 * Solo estilos: no contiene lógica ni reglas de negocio.
 *
 * ⚠️ White label (guía §1): aquí NO van colores de marca (primary, hover,
 * soft, superficies de marca). Esos se resuelven en runtime por tenant en
 * `theme/brand.js` (getBrand/resolveBrand) o vía `theme.palette` de MUI.
 */
export const PINPEO = {
  // Superficies
  background: '#F7FAF8',
  surface: '#FFFFFF',

  // Bordes y divisores
  border: '#E1E8E4',
  borderStrong: '#D4DED8', // bordes de inputs/botones outlined
  divider: '#EDF2EF',
  track: '#E7EDE9', // fondo de grupos segmentados (chips/densidad)

  // Texto
  text: '#16211B',
  textSoft: '#3C4A42',
  textSecondary: '#5B6B62',
  textMuted: '#8A968F',
  textFaint: '#B7C2BB',

  // Filas de tabla
  rowHover: '#F0F7F3',
  rowSelected: '#EDF6F0',
  // zebra: 'rgba(231,242,236,.25)'

  // Sombras
  shadowCard: '0 8px 28px rgba(11,61,38,.08)',
  shadowPopover: '0 16px 40px rgba(11,61,38,.18)',

  // Radios
  radius: 10, // controles (botones, inputs, dropdowns)
  radiusCard: 14, // cards y tablas
  // pills: 99

  // Tipografías
  fontFamily: '"Instrument Sans", "Roboto", "Helvetica", "Arial", sans-serif',
  fontFamilyMono: '"IBM Plex Mono", "Roboto Mono", monospace',
};

// Pills de estado semánticas (bg / fg)
export const STATUS_PILL = {
  success: {
    bg: '#E1F4E8',
    fg: '#0E7C43',
  }, // aprobada
  warning: {
    bg: '#FCF3DC',
    fg: '#9A6B0B',
  }, // pendiente
  error: {
    bg: '#FBE7E5',
    fg: '#B3392E',
  }, // rechazada
  info: {
    bg: '#E8EDF6',
    fg: '#3D5A99',
  }, // reembolso/reverso
  default: {
    bg: '#EDF2EF',
    fg: '#5B6B62',
  },
};

export default PINPEO;
